import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudCourses = () => import('./staff/crudCourses')
const ViewStaffCrudCategories = () => import('./staff/crudCategories')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'CoursesStaffDashboard',
  crudCourses: 'CoursesStaffCrudCourses',
  crudCategories: 'CoursesStaffCrudCategories',
}

const router =
  [
    {
      path: '/st/courses',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cursos',
          }          
        },  
        {
          path: 'courses',
          name: VIEWS.crudCourses,
          component: ViewStaffCrudCourses,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de Cursos',
          }          
        },                
        {
          path: 'categories',
          name: VIEWS.crudCategories,
          component: ViewStaffCrudCategories,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Categorías de Cursos',
          }          
        },                              
      ]
    },

    {
      path: '/cu/courses',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/courses',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
